<template>
    <!--/ Section Blog Star /-->
    <section id="blog" class="blog-mf sect-pt4 route">
        <div class="container">
        <div class="row">
            <div class="col-sm-12">
            <div class="title-box text-center">
                <h3 class="title-a mt-5" style="margin-top: 11vh; font-family: 'Libre Baskerville', serif; color: #3e4095;  font-size: 2rem;">
                Blog
                </h3>
                <p class="subtitle-a" style="font-family: 'Times new roman'">
                As melhores publicações sobre agronegócio você encontra aqui!
                </p>
                <div class="line-mf"></div>
            </div>
            </div>
        </div>
        <div class="row">
                <blog-card
                    v-for='item in blogPosts'
                    :blogPost="item"
                    v-bind:key="item.id"
                ></blog-card>        
            <!-- <div class="col-md-12 mt-5 text-center">
                
            <br>
            <h1>EM CONSTRUÇÃO</h1></div> -->
        </div>
        <div class="row">
            <div class="col-md-12 d-flex justify-content-center mt-3">
                <a href="/externalBlog" class="btn btn-light" style="font-family: 'Libre Baskerville', serif; color: #3e4095;"><i class="fas fa-blog"></i> Acesse nosso blog completo</a>
            </div>
        </div>
        </div>
    </section>
    <!--/ Section Blog End /-->
</template>
<script>
import BlogCard from "./BlogCard.vue";
export default {
    data(){
        return{
            blogPosts: []
        }
    },
    mounted(){
        axios.get('/api/blogFirstThree')
        .then(({data}) => {
            this.blogPosts = data;
        })
        .catch(({data}) => {
            console.log("Sem resposta");
        });
        $('.back-to-top').click();
    },
    components: {
        'blog-card': BlogCard
    }
}
</script>

